import React, {useEffect} from 'react'
import CountUp from "react-countup";
import { Link } from 'react-router-dom';
import AOS from 'aos';
import aboutUs from '../Assets/Images/about-us.avif'
import expertDesigners from '../Assets/Images/creative-designers.avif'
import Testimonials from './Testimonials'
import graphicsDesignServices from '../Assets/Images/graphics-desining-services (1).gif'




function Company() {

  useEffect(() => {
    AOS.init();
  }, []);
  return (
    <div>
      <section className="inner-head" data-aos="fade-up" data-aos-duration="2000">
        <div className="overlay1">
          <div className="container py-2">
            <div className="row d-flex justify-content-cente align-items-center">
              <div className="col-md-5 head-content">
                <div className="section-header mb-3">
                  <h6>Explore Our Services</h6>
                  <h2>Imaginative Designs, Tangible Impact</h2>
                </div>
                <p>Experience boundless creativity with our graphic design services. Where ideas flourish, we bring your vision to vibrant life, ensuring a lasting impact.</p>
              </div>
              <div className="col-md-7">
                <img src={graphicsDesignServices} alt="" className="img-fluid" />
              </div>
            </div>
          </div>
        </div>
      </section>


      <section className="about-us mb-4">
        <div className="container pt-5">
          <div className="row d-flex justify-cotent-center align-items-center ">
            <div className="col-md-7" data-aos="fade-up" data-aos-duration="2000">
              <div className="section-header mb-4">
                <h6>Who We Are</h6>
                <h2>Crafting Visual Excellence With Precision And Passion</h2>
              </div>
              <p className='mb-4'>Farooq Graphics is not just a graphics designing company; we are storytellers, visual magicians, and creative strategists. Established with a passion for transforming ideas into captivating visuals, our team of talented designers is dedicated to bringing your vision to life. With a commitment to excellence and a keen eye for detail, we strive to redefine the boundaries of graphic design, ensuring that each project we undertake is a masterpiece in its own right.</p>
              <div className="row d-flex justify-content-center align-items-center stats mb-4">
                <div className="col-md-4 col-4">
                <CountUp
                    start={0}
                    end={150}
                    duration={3}
                    className='counter stat-1'
                />
                <h3>Expert Designers</h3>
                  
                </div>
                <div className="col-md-4 col-4">
                <CountUp
                    start={0}
                    end={500}
                    duration={3}
                    className='counter stat-2'
                />
                <h3>Satisfied Clients</h3>
                </div>
                <div className="col-md-4 col-4 extra" style={{marginRight: '-28px', borderRight: 'none'}}>
                <CountUp
                    start={0}
                    end={100}
                    duration={3}
                    className='counter stat-3'
                />
                <h3>Client Satisfaction</h3>
                </div>
              </div>
            </div>
            <div className="col-md-5 order-md-2" data-aos="fade-down" data-aos-duration="2000">
              <div className="img-overlay">
              <img src={aboutUs} alt="graphic-designing-company" className="img-fluid" />
              <div className="overlay"></div>
              </div>
            </div>
          </div>
          <div className='d-flex button-box mt-3'>
            <Link to='/contact'><button className="second-button">Connect Now</button></Link>
          </div>
        </div>
      </section>


      <section className='delivery p-4'>
        <div className="container-fluid">
          <div className="row d-flex justify-content-center align-items-center">
            <div className="col-md-6 first-col" data-aos="fade-right" data-aos-duration="2000">
            <h4 className='delivery-heading mb-3'>Delivering Comprehensive Creative Concept to Production Solutions with Precision</h4>
            </div>
            <div className="col-md-6 second-col" data-aos="fade-left" data-aos-duration="2000">
              <div className="row" style={{flexDirection: 'column'}}>
                <div className="col-md-12 inside-col">
                  <h5>Design Department</h5>
                  <p>Our team of creative designers can refresh your brand image- or give it a complete modern touch. We work with executive teams at large national corporations and small business owners to understand their vision for their brand.</p>
                </div>
                <div className="col-md-12 inside-col">
                <h5>Color</h5>
                  <p>Our color-calibrated monitors will efficiently allow you to view the same color combinations on your computer screen that you wish to see on paper, resulting in complete client satisfaction.</p>
                </div>
                <div className="col-md-12 inside-col">
                <h5>Digital Press Proofing</h5>
                  <p>For our clients’ ultimate satisfaction, we provide with digital & press proof before printing the job, making sure that we deliver the product with 100% accuracy and delivered what we committed.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="tag-line" data-aos="fade-up" data-aos-duration="2000">
        <div className="tag-overlay">
          <div className="container">
            <div className="row py-6 d-flex justify-content-center align-items-center">
              <div className="col-md-8 text-center">
                <h1 className='text-light slogan'>We bleed C.M.Y.K., we breathe Helvetica, we love Whitespace. Yes, we are designers</h1>
              </div>
            </div>
          </div>
        </div>
      </section>


      <section className="no-design mt-5 mb-3">
        <div className="container">
          <div className="row d-flex justify-content-center align-items-center">
            <div className="col-md-6" data-aos="fade-right" data-aos-duration="2000">
              <div className="section-header mb-4">
                <h6>No Design Ideas?</h6>
                <h2>Let Our Expert Designers Inspire Your Vision! </h2>
              </div>
              <p>We are a full-fledged printing house that provides you with end-to-end high quality printing solutions. We let your thoughts & emotions take shape, color & designs that are etched forever in one’s memories. <br/>ur designers thrive on the challenge of turning abstract concepts into visually compelling stories. Partner with us to experience design that not only meets your expectations but exceeds them, setting your project apart with a distinct and memorable identity. </p>
              <Link to="/contact"><button className="first-button mb-4">Connnect With Us <span>&rarr;</span></button></Link>
            </div>
            <div className="col-md-6" data-aos="fade-left" data-aos-duration="2000">
            <img src={expertDesigners} alt="" className="img-fluid" />
            </div>
          </div>
        </div>
      </section>

      <div style={{backgroundColor: '#f3f6fb'}} className='pb-4' data-aos="fade-up" data-aos-duration="2000">
      <Testimonials />
      </div>




    </div>
  )
}

export default Company
